import { render, staticRenderFns } from "./orderTest.vue?vue&type=template&id=7bfa615a&"
import script from "./orderTest.vue?vue&type=script&lang=js&"
export * from "./orderTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports